(function( $, doc ) {
    "use strict";

    (function(){

        $(document).ready(function() {

            // SELECT2 wpmudev-ui
            $(".wpmudev-select").select2({
                allowClear: false,
                minimumResultsForSearch: Infinity,
                containerCssClass: "wpmudev-select2",
                dropdownCssClass: "wpmudev-select2-dropdown"
            });

            // SELECT2 forminator-ui
            $(".wpmudev-form-field--select").select2({
                allowClear: false,
                minimumResultsForSearch: Infinity,
                containerCssClass: "wpmudev-form-field--select2",
                dropdownCssClass: "wpmudev-form-field--select2-dropdown"
            });
            
        });

    }());

}( jQuery, document ));